exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".board-list-header input[data-v-1a138929]{border:0;font-size:25px;font-weight:700;font-family:Fira Sans,sans-serif;background:transparent;border-radius:0;max-height:256px;min-height:30px;padding:0;display:block;width:100%;caret-color:#1e73bd}", ""]);

// exports
